// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
} */



/* Reset and base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
  color: #333;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* App Layout */
.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1 1;
}

/* Container utilities */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* Flexbox utilities */
.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.flex-grow {
  flex-grow: 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

/* Background colors */
.bg-gray-50 {
  background-color: #f9fafb;
}

.bg-white {
  background-color: white;
}

.bg-blue-600 {
  background-color: #2563eb;
}

.bg-blue-700 {
  background-color: #1d4ed8;
}

.bg-blue-800 {
  background-color: #1e40af;
}

.bg-gray-800 {
  background-color: #1f2937;
}

.bg-red-50 {
  background-color: #fef2f2;
}

/* Text colors */
.text-white {
  color: white;
}

.text-gray-900 {
  color: #111827;
}

.text-gray-700 {
  color: #374151;
}

.text-gray-600 {
  color: #4b5563;
}

.text-gray-400 {
  color: #9ca3af;
}

.text-blue-600 {
  color: #2563eb;
}

.text-blue-500 {
  color: #3b82f6;
}

.text-blue-200 {
  color: #bfdbfe;
}

.text-red-800 {
  color: #991b1b;
}

.text-red-600 {
  color: #dc2626;
}

.text-red-500 {
  color: #ef4444;
}

.text-red-400 {
  color: #f87171;
}

/* Typography */
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.font-bold {
  font-weight: 700;
}

.font-semibold {
  font-weight: 600;
}

.font-medium {
  font-weight: 500;
}

.text-center {
  text-align: center;
}

/* Spacing */
.min-h-screen {
  min-height: 100vh;
}

.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.p-4 {
  padding: 1rem;
}

.pt-8 {
  padding-top: 2rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-1 {
  margin-top: 0.25rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.ml-3 {
  margin-left: 0.75rem;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

/* Borders */
.border {
  border-width: 1px;
}

.border-gray-300 {
  border-color: #d1d5db;
}

.border-red-200 {
  border-color: #fecaca;
}

.border-gray-700 {
  border-color: #374151;
}

.border-transparent {
  border-color: transparent;
}

.border-t {
  border-top-width: 1px;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-md {
  border-radius: 0.375rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

/* Shadows */
.shadow {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

/* Forms */
.appearance-none {
  appearance: none;
}

.block {
  display: block;
}

.w-full {
  width: 100%;
}

.h-5 {
  height: 1.25rem;
}

.w-5 {
  width: 1.25rem;
}

/* Focus styles */
.focus\\:outline-none:focus {
  outline: 0;
}

.focus\\:ring-2:focus {
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}

.focus\\:ring-blue-500:focus {
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}

.focus\\:border-blue-500:focus {
  border-color: #3b82f6;
}

.focus\\:ring-offset-2:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(59, 130, 246, 0.5);
}

/* Hover effects */
.hover\\:text-blue-500:hover {
  color: #3b82f6;
}

.hover\\:text-blue-200:hover {
  color: #bfdbfe;
}

.hover\\:text-white:hover {
  color: white;
}

.hover\\:text-red-500:hover {
  color: #ef4444;
}

.hover\\:bg-blue-700:hover {
  background-color: #1d4ed8;
}

.hover\\:bg-blue-800:hover {
  background-color: #1e40af;
}

/* Disabled states */
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

/* Spacing utilities */
.space-y-6 > * + * {
  margin-top: 1.5rem;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}

.space-x-6 > * + * {
  margin-left: 1.5rem;
}

.space-x-4 > * + * {
  margin-left: 1rem;
}

/* Grid */
.grid {
  display: grid;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.gap-8 {
  gap: 2rem;
}

/* Underline */
.underline {
  text-decoration: underline;
}

/* Width utilities */
.sm\\:max-w-md {
  max-width: 28rem;
}

.sm\\:w-full {
  width: 100%;
}

.sm\\:mx-auto {
  margin-left: auto;
  margin-right: auto;
}

/* Responsive design */
@media (min-width: 640px) {
  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  
  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  
  .sm\\:rounded-lg {
    border-radius: 0.5rem;
  }
  
  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  
  .sm\\:w-full {
    width: 100%;
  }
  
  .sm\\:max-w-md {
    max-width: 28rem;
  }
}

@media (min-width: 768px) {
  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

/* Additional custom styles for better appearance */
input, button {
  border-radius: 0.375rem;
  transition: all 0.2s ease-in-out;
}

input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

button {
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

button:disabled {
  cursor: not-allowed;
}

a {
  text-decoration: none;
  transition: color 0.2s ease-in-out;
}

/* Header specific styles */
header a {
  color: inherit;
}

/* Footer specific styles */
footer {
  margin-top: auto;
}

/* Form inputs */
input[type="email"],
input[type="password"],
input[type="text"] {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
}

input[type="email"]:focus,
input[type="password"]:focus,
input[type="text"]:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Button styles */
button[type="submit"] {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: white;
  background-color: #2563eb;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

button[type="submit"]:hover:not(:disabled) {
  background-color: #1d4ed8;
}

button[type="submit"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Link buttons */
.btn-link {
  background-color: #1d4ed8;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  text-decoration: none;
  display: inline-block;
  transition: background-color 0.2s ease-in-out;
}

.btn-link:hover {
  background-color: #1e40af;
  color: white;
}

/* Error message styles */
.error-message {
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 0.375rem;
  padding: 1rem;
  margin: 1rem 0;
  display: flex;
  align-items: flex-start;
}

.error-message svg {
  height: 1.25rem;
  width: 1.25rem;
  color: #f87171;
  flex-shrink: 0;
}

.error-message p {
  font-size: 0.875rem;
  color: #991b1b;
  margin-left: 0.75rem;
}

/* Mobile responsiveness improvements */
@media (max-width: 640px) {
  .container {
    padding: 0 0.5rem;
  }
  
  header .flex {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  header nav {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .grid-cols-1 {
    grid-template-columns: 1fr;
  }
  
  .space-x-6 > * + * {
    margin-left: 0;
    margin-top: 0.5rem;
  }
  
  .space-x-4 > * + * {
    margin-left: 0;
    margin-top: 0.5rem;
  }
  
  header nav {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  header .space-x-6 {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  header .space-x-6 > * + * {
    margin-left: 0;
  }
}

/* Ensure proper layout for login page */
.login-container {
  min-height: 100vh;
  background-color: #f9fafb;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem 0;
}

.login-form-container {
  margin: 2rem auto 0;
  width: 100%;
  max-width: 28rem;
}

.login-form {
  background-color: white;
  padding: 2rem 1rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border-radius: 0.5rem;
}

@media (min-width: 640px) {
  .login-form {
    padding: 2rem 2.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;GAYG;;;;AAIH,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;aACW;AACb;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,2EAA2E;AAC7E;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mFAAmF;AACrF;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,UAAU;AACZ;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8DAA8D;AAChE;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,SAAS;AACX;;AAEA,cAAc;AACd;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,mDAAmD;AACnD;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;;;EAGE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,2EAA2E;EAC3E,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n} */\n\n\n\n/* Reset and base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 1.6;\n  color: #333;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* App Layout */\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nmain {\n  flex: 1;\n}\n\n/* Container utilities */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n/* Flexbox utilities */\n.flex {\n  display: flex;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.flex-grow {\n  flex-grow: 1;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n\n/* Background colors */\n.bg-gray-50 {\n  background-color: #f9fafb;\n}\n\n.bg-white {\n  background-color: white;\n}\n\n.bg-blue-600 {\n  background-color: #2563eb;\n}\n\n.bg-blue-700 {\n  background-color: #1d4ed8;\n}\n\n.bg-blue-800 {\n  background-color: #1e40af;\n}\n\n.bg-gray-800 {\n  background-color: #1f2937;\n}\n\n.bg-red-50 {\n  background-color: #fef2f2;\n}\n\n/* Text colors */\n.text-white {\n  color: white;\n}\n\n.text-gray-900 {\n  color: #111827;\n}\n\n.text-gray-700 {\n  color: #374151;\n}\n\n.text-gray-600 {\n  color: #4b5563;\n}\n\n.text-gray-400 {\n  color: #9ca3af;\n}\n\n.text-blue-600 {\n  color: #2563eb;\n}\n\n.text-blue-500 {\n  color: #3b82f6;\n}\n\n.text-blue-200 {\n  color: #bfdbfe;\n}\n\n.text-red-800 {\n  color: #991b1b;\n}\n\n.text-red-600 {\n  color: #dc2626;\n}\n\n.text-red-500 {\n  color: #ef4444;\n}\n\n.text-red-400 {\n  color: #f87171;\n}\n\n/* Typography */\n.text-3xl {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.text-center {\n  text-align: center;\n}\n\n/* Spacing */\n.min-h-screen {\n  min-height: 100vh;\n}\n\n.py-12 {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n\n.py-8 {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.py-4 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.px-6 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.px-8 {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n.px-10 {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n\n.p-4 {\n  padding: 1rem;\n}\n\n.pt-8 {\n  padding-top: 2rem;\n}\n\n.mt-8 {\n  margin-top: 2rem;\n}\n\n.mt-6 {\n  margin-top: 1.5rem;\n}\n\n.mt-4 {\n  margin-top: 1rem;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.mt-1 {\n  margin-top: 0.25rem;\n}\n\n.mb-4 {\n  margin-bottom: 1rem;\n}\n\n.ml-3 {\n  margin-left: 0.75rem;\n}\n\n.my-4 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n/* Borders */\n.border {\n  border-width: 1px;\n}\n\n.border-gray-300 {\n  border-color: #d1d5db;\n}\n\n.border-red-200 {\n  border-color: #fecaca;\n}\n\n.border-gray-700 {\n  border-color: #374151;\n}\n\n.border-transparent {\n  border-color: transparent;\n}\n\n.border-t {\n  border-top-width: 1px;\n}\n\n.rounded {\n  border-radius: 0.25rem;\n}\n\n.rounded-md {\n  border-radius: 0.375rem;\n}\n\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n\n/* Shadows */\n.shadow {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n\n.shadow-sm {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.shadow-lg {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n/* Forms */\n.appearance-none {\n  appearance: none;\n}\n\n.block {\n  display: block;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.h-5 {\n  height: 1.25rem;\n}\n\n.w-5 {\n  width: 1.25rem;\n}\n\n/* Focus styles */\n.focus\\:outline-none:focus {\n  outline: 0;\n}\n\n.focus\\:ring-2:focus {\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);\n}\n\n.focus\\:ring-blue-500:focus {\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);\n}\n\n.focus\\:border-blue-500:focus {\n  border-color: #3b82f6;\n}\n\n.focus\\:ring-offset-2:focus {\n  box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(59, 130, 246, 0.5);\n}\n\n/* Hover effects */\n.hover\\:text-blue-500:hover {\n  color: #3b82f6;\n}\n\n.hover\\:text-blue-200:hover {\n  color: #bfdbfe;\n}\n\n.hover\\:text-white:hover {\n  color: white;\n}\n\n.hover\\:text-red-500:hover {\n  color: #ef4444;\n}\n\n.hover\\:bg-blue-700:hover {\n  background-color: #1d4ed8;\n}\n\n.hover\\:bg-blue-800:hover {\n  background-color: #1e40af;\n}\n\n/* Disabled states */\n.disabled\\:opacity-50:disabled {\n  opacity: 0.5;\n}\n\n/* Spacing utilities */\n.space-y-6 > * + * {\n  margin-top: 1.5rem;\n}\n\n.space-y-2 > * + * {\n  margin-top: 0.5rem;\n}\n\n.space-x-6 > * + * {\n  margin-left: 1.5rem;\n}\n\n.space-x-4 > * + * {\n  margin-left: 1rem;\n}\n\n/* Grid */\n.grid {\n  display: grid;\n}\n\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.gap-8 {\n  gap: 2rem;\n}\n\n/* Underline */\n.underline {\n  text-decoration: underline;\n}\n\n/* Width utilities */\n.sm\\:max-w-md {\n  max-width: 28rem;\n}\n\n.sm\\:w-full {\n  width: 100%;\n}\n\n.sm\\:mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Responsive design */\n@media (min-width: 640px) {\n  .sm\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  \n  .sm\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  \n  .sm\\:rounded-lg {\n    border-radius: 0.5rem;\n  }\n  \n  .sm\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .sm\\:w-full {\n    width: 100%;\n  }\n  \n  .sm\\:max-w-md {\n    max-width: 28rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .md\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n/* Additional custom styles for better appearance */\ninput, button {\n  border-radius: 0.375rem;\n  transition: all 0.2s ease-in-out;\n}\n\ninput:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\nbutton {\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\nbutton:disabled {\n  cursor: not-allowed;\n}\n\na {\n  text-decoration: none;\n  transition: color 0.2s ease-in-out;\n}\n\n/* Header specific styles */\nheader a {\n  color: inherit;\n}\n\n/* Footer specific styles */\nfooter {\n  margin-top: auto;\n}\n\n/* Form inputs */\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"text\"] {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n}\n\ninput[type=\"email\"]:focus,\ninput[type=\"password\"]:focus,\ninput[type=\"text\"]:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Button styles */\nbutton[type=\"submit\"] {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: white;\n  background-color: #2563eb;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\nbutton[type=\"submit\"]:hover:not(:disabled) {\n  background-color: #1d4ed8;\n}\n\nbutton[type=\"submit\"]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Link buttons */\n.btn-link {\n  background-color: #1d4ed8;\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 0.25rem;\n  text-decoration: none;\n  display: inline-block;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.btn-link:hover {\n  background-color: #1e40af;\n  color: white;\n}\n\n/* Error message styles */\n.error-message {\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 0.375rem;\n  padding: 1rem;\n  margin: 1rem 0;\n  display: flex;\n  align-items: flex-start;\n}\n\n.error-message svg {\n  height: 1.25rem;\n  width: 1.25rem;\n  color: #f87171;\n  flex-shrink: 0;\n}\n\n.error-message p {\n  font-size: 0.875rem;\n  color: #991b1b;\n  margin-left: 0.75rem;\n}\n\n/* Mobile responsiveness improvements */\n@media (max-width: 640px) {\n  .container {\n    padding: 0 0.5rem;\n  }\n  \n  header .flex {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n  \n  header nav {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  \n  .grid-cols-1 {\n    grid-template-columns: 1fr;\n  }\n  \n  .space-x-6 > * + * {\n    margin-left: 0;\n    margin-top: 0.5rem;\n  }\n  \n  .space-x-4 > * + * {\n    margin-left: 0;\n    margin-top: 0.5rem;\n  }\n  \n  header nav {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  header .space-x-6 {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  header .space-x-6 > * + * {\n    margin-left: 0;\n  }\n}\n\n/* Ensure proper layout for login page */\n.login-container {\n  min-height: 100vh;\n  background-color: #f9fafb;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 3rem 0;\n}\n\n.login-form-container {\n  margin: 2rem auto 0;\n  width: 100%;\n  max-width: 28rem;\n}\n\n.login-form {\n  background-color: white;\n  padding: 2rem 1rem;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  border-radius: 0.5rem;\n}\n\n@media (min-width: 640px) {\n  .login-form {\n    padding: 2rem 2.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
